<template>
    <div class="relative">
        <button v-if="isCollapsable" class="absolute -start-11 top-2 flex h-11 w-11 justify-center" @click.stop="toggle">
            <chevron-down :class="{ 'rotate-270': closed }" />
        </button>
        <slot name="toggler" />
        <div :class="{ 'h-0 overflow-hidden': closed, 'h-auto': !closed }">
            <slot />
        </div>
    </div>
</template>
<script setup>
import ChevronDown from '../../icons/ChevronDown.vue';
import { ref, watch } from 'vue';

const emit = defineEmits(['update:closed']);
const props = defineProps({
    /**
     * Controlled closed state. Use with v-model:closed
     * If not provided, the component manages its own state initialized by defaultClosed.
     */
    closed: {
        type: Boolean,
        default: null,
    },
    /**
     * Initial closed state when not controlled via v-model:closed
     */
    defaultClosed: {
        type: Boolean,
        default: false,
    },
    /**
     * Whether the component can be collapsed
     */
    isCollapsable: {
        type: Boolean,
        default: true,
    },
});

const isControlled = () => props.closed !== null && props.closed !== undefined;

const closed = ref(props.closed ?? props.defaultClosed);

watch(
    () => props.closed,
    (value) => {
        if (isControlled()) {
            closed.value = value;
        }
    },
    { immediate: true },
);

const toggle = () => {
    const next = !closed.value;
    if (isControlled()) {
        emit('update:closed', next);
    } else {
        closed.value = next;
        emit('update:closed', next);
    }
};
</script>
